import { ProjectsWrapper } from 'components/wrappers/ProjectsWrapper'
import './ProjectsPage.scss'

export const ProjectsPage = () => {
    return (
        <div className="projectspage">
            <h1 className="projectspage__title">Projects</h1>
            <section className="projectspage__showcase">
                <ProjectsWrapper />
            </section>
        </div>
    )
}